import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants/srp';
import FacetDataContext from '~/context/common/FacetDataContext';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';
import fetchFacetData from '~/services/common/fetchFacetData';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetFacetData(facetDataWasFetched?: boolean): void {
  const {
    facetData: { setData, setError, setLoading },
    setPagination
  } = useContext(FacetDataContext);
  const isFirstRenderAndFacetDataWasFetched = useRef(
    facetDataWasFetched ?? true
  );

  const { request } = useGenerateInventoryRequest(MAX_PAGE_SIZE_DEFAULT, {
    includePageNumber: false,
    limitRequestedFeatures: true
  });

  useEffectWithController(
    controller => {
      if (isFirstRenderAndFacetDataWasFetched.current) {
        isFirstRenderAndFacetDataWasFetched.current = false;

        return;
      }

      setLoading();

      fetchFacetData(
        {
          ...request
        },
        controller
      )
        .then(({ data: { pagination, ...facets } }) => {
          setData(facets);
          setPagination(pagination);
        })
        .catch(
          generateErrorLogger(
            'Facet data',
            {},
            { callback: setError, controller }
          )
        );
    },
    [request, setData, setError, setLoading, setPagination]
  );
}
